export class Level 
{
    public LevelId : number;
    public LevelName : string;
    public LevelCode : string;
    public DecisionId : number;
    public IsActive : boolean;
}